import { render, staticRenderFns } from "./InvoiceCorpCard.vue?vue&type=template&id=15bf4141&"
import script from "./InvoiceCorpCard.vue?vue&type=script&lang=js&"
export * from "./InvoiceCorpCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports